import {RsnSelect} from '@raison/ui-kit';
import {useQuery} from '@tanstack/react-query';
import React from 'react';
import {useVaspListOptions} from '../api/fetchVaspOptions';

export type VASP = {
    id: string;
    name: string;
};

export function VaspPicker({value, onChange, ...props}: Omit<RsnSelect.Props<VASP | null>, 'options'>) {
    const {isLoading, isError, ...query} = useQuery({
        ...useVaspListOptions(),
        select: ({items}) => {
            return items.map(
                (vasp): RsnSelect.Option<VASP | null> => ({
                    value: vasp,
                    label: vasp.name,
                })
            );
        },
        retry: 3,
    });

    let options = query.data;
    if (isLoading) {
        options = [{label: 'Loading...', value: null}];
    }
    if (isError) {
        options = [{label: 'Failed to load options.', value: null}];
        props.isInvalid = true;
        props.helperText = 'Please try again later';
    }

    return (
        <RsnSelect.Search
            //
            withIcon
            virtualized
            {...props}
            options={options}
            value={value}
            onChange={onChange}
            disabled={isLoading || isError}
        />
    );
}
